import { useQuery } from "@tanstack/react-query";
import { fetchStaticAll } from "../api/fetchStaticAll";

export const useStaticAll = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["staticAll"],
    queryFn: fetchStaticAll,
  });

  return { data: data?.result || [], error, isLoading };
};

